import React, { useEffect, useState } from 'react'
import { Message } from 'semantic-ui-react'

export const ImageWarnings = ({ warnings }: { warnings: string[] }) => {
  const [visible, setVisible] = useState<boolean>(true)

  useEffect(() => {
    setVisible(true)
  }, [warnings])

  if (warnings.length === 0 || visible === false) return null

  return (
    <Message color="yellow" onDismiss={() => setVisible(!visible)}>
      <Message.Header>Photo Upload Warnings</Message.Header>
      <Message.List items={warnings} />
    </Message>
  )
}
